import React, { useEffect, useState } from 'react';
import { GeoJSON } from 'react-leaflet';
import { getGeometryLayerRequestPath } from '../../config/geometry-layer-urls';
import { apiGet } from '../../apiHelpers';
import { useDisplayPreferences } from '../../displayPreferences-context';
export function VistaBoundaryLayer() {
    const [boundaryGeojson, setBoundaryGeojson] = useState(null);
    const { vista } = useDisplayPreferences();
    useEffect(() => {
        apiGet(getGeometryLayerRequestPath('vista'))
            .then(data => {
            if (data && data.type === 'FeatureCollection') {
                setBoundaryGeojson(data);
            }
            else {
                setBoundaryGeojson(null);
            }
        })
            .catch(() => setBoundaryGeojson(null));
    }, []);
    if (vista == "enabled") {
        return boundaryGeojson &&
            React.createElement(GeoJSON, { attribution: ' London Views Management Framework (LVMF) \u2013 Extended background vistas from <a href=https://data.london.gov.uk/dataset/london-views-management-framework-lvmf-extended-background-vistas>London Datastore</a>: <a href=https://creativecommons.org/licenses/by/4.0/legalcode>CC-BY-SA 4.0</a> by the Greater London Authority (GLA)', data: boundaryGeojson, style: { color: '#0f0', fill: true, weight: 1, opacity: 0.6 } });
    }
    else {
        return React.createElement(React.Fragment, null);
    }
}
